import React, { useState, useEffect } from "react";
import {
  Row, Col, Form, FormGroup, Label, Input, Button, FormFeedback, Card, CardBody, Alert
} from "reactstrap";
import Select from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import {
  urlListarGeneros,
  urlListarEstadosCiviles,
  urlListarProvincias,
  urlCiudadesAP,
  urlGuardarDatosFacturacionC,
  urlCreaFacturacionAP
} from "../../constants/urls";
import { apiGet, apiPost2 } from "../../api";
import { useToasts } from 'react-toast-notifications';
import { useLocation, useHistory } from 'react-router-dom';
import { guardarFacturacionFetch } from "../../redux/actions/aCotizacion";

const tiposIdentificacion = [
  { id: "1", name: "Cédula" },
  { id: "2", name: "RUC" },
  { id: "3", name: "Pasaporte" },
];

const validarIdentificacionEcuador = (valor, tipo) => {
  if (tipo === "1") return /^\d{10}$/.test(valor);
  if (tipo === "2") return /^\d{13}$/.test(valor);
  if (tipo === "3") return /^[a-zA-Z0-9]{5,15}$/.test(valor);
  return false;
};

const FormularioContratante = ({ onSubmit, setLoading, urlRegresar, urlContinuar, idCarrito, carDatosContratante }) => {
  const { addToast } = useToasts();
  const history = useHistory();
  const [form, setForm] = useState({
    tipoIdentificacion: "",
    identificacion: "",
    nombres: "",
    apellidos: "",
    estadoCivil: "",
    genero: "",
    provincia: "",
    ciudad: "",
    fechaNacimiento: "",
    correo: "",
    direccion: "",
    celular: "",
    mismosDatos: true,
    fechaEmisionPasaporte: "",
    fechaCaducidadPasaporte: "",
    fechaIngresoPais: ""
  });

  const [generos, setGeneros] = useState([]);
  const [estadosCiviles, setEstadosCiviles] = useState([]);
  const [provincias, setProvincias] = useState([]);
  const [ciudades, setCiudades] = useState([]);
  const [errors, setErrors] = useState({});
  const [mostrarAlertaForm, setMostrarAlertaForm] = useState(false);

  // 🔹 Helper para saber si es RUC (para ocultar/renombrar campos)
  const esRUC = form.tipoIdentificacion === "2";

  const actualizarDesdeConsulta = (datos, tipo) => {
    const {
      nombre = "",
      nombres = "",
      apellidos = "",
      direccion = "",
      provCodigoCore = "",
      provNombre = "",
      ciuCodigoCore = "",
      ciuNombre = "",
      correo = "",
      celular = "",
      generoCod = "",
      cliCodigoEstadoCivil = "",
      fechNacimiento = null,
    } = datos;

    const fecha = fechNacimiento
      ? fechNacimiento.includes("/")
        ? fechNacimiento.split("/").reverse().join("-")
        : fechNacimiento.split("T")[0]
      : "";
    consultarProvincia(provCodigoCore);

    const nuevosDatos = {
      direccion,
      correo,
      celular,
      provincia: provCodigoCore,
      ciudad: ciuCodigoCore,
      fechaNacimiento: fecha
    };

    if (tipo === "2") {
      nuevosDatos.nombres = nombre; // Para RUC, usar razón social en 'nombres'
      nuevosDatos.apellidos = "";   // Asegurar apellidos vacío
      nuevosDatos.genero = "";
      nuevosDatos.estadoCivil = "";
    } else if (tipo === "1") {
      let estadoCivilFinal = cliCodigoEstadoCivil;
      if ((estadoCivilFinal === "" || estadoCivilFinal === null || estadoCivilFinal === undefined) && datos.cliEstadoCivil) {
        const encontrado = estadosCiviles.find(
          e => e.ecivNombre.toUpperCase().trim() === datos.cliEstadoCivil.toUpperCase().trim()
        );
        if (encontrado) {
          estadoCivilFinal = encontrado.ecivCodigoCore;
        }
      }

      let generoFinal = generoCod;
      if ((generoFinal === "" || generoFinal === null || generoFinal === undefined) && datos.generoNom) {
        const encontrado = generos.find(
          g => g.genDescripcion.toUpperCase().trim() === datos.generoNom.toUpperCase().trim()
        );
        if (encontrado) {
          generoFinal = encontrado.genCodigoCore;
        }
      }

      nuevosDatos.estadoCivil = estadoCivilFinal;
      nuevosDatos.nombres = nombres;
      nuevosDatos.apellidos = apellidos;
      nuevosDatos.genero = generoFinal;
    }

    setForm(prev => ({ ...prev, ...nuevosDatos }));
  };

  useEffect(() => {
    const cargarCatalogos = async () => {
      try {
        const [resGeneros, resEstadosCiviles, resProvincias] = await Promise.all([
          apiGet(urlListarGeneros),
          apiGet(urlListarEstadosCiviles),
          apiGet(urlListarProvincias)
        ]);

        if (resGeneros && resGeneros.transaccion) setGeneros(resGeneros.generos || []);
        if (resEstadosCiviles && resEstadosCiviles.transaccion) setEstadosCiviles(resEstadosCiviles.eciviles || []);
        if (resProvincias && resProvincias.transaccion) setProvincias(resProvincias.provinciaFormato || []);
      } catch (error) {
        console.error("Error al cargar catálogos:", error);
        addToast("Error al cargar catálogos", { appearance: "error" });
      }
    };

    cargarCatalogos();
  }, []);

  useEffect(() => {
    if (carDatosContratante) {
      console.log("cardatos", carDatosContratante)
      const {
        tipoIdentificacion,
        identificacion,
        nombres,
        apellidos,
        correo,
        direccion,
        celular,
        estadoCivil,
        genero,
        provincia,
        ciudad,
        fechaNacimiento,
        cliNombre1,
        cliNombre2,
        cliApellido1,
        cliApellido2,
        cliIdentificacion,
        cliTelefono,
        cliDireccion,
        cliFechaNacimiento,
        cliGenero,
        cliCodGenero,
        cliEstadoCivil,
        cliRazonSocial,
        cliEmail,
        cliFechaConstitucion,
        fechaEmisionPasaporte,
        fechaCaducidadPasaporte,
        fechaIngresoPais
      } = carDatosContratante;

      const id = identificacion || cliIdentificacion || "";
      let tipoIdentificacionDetectado = "";

      if (id.length === 10) {
        tipoIdentificacionDetectado = "1"; // Cédula
      } else if (id.length === 13) {
        tipoIdentificacionDetectado = "2"; // RUC
      }

      const tipoFinal = tipoIdentificacion || tipoIdentificacionDetectado;
      const esRucDetectado = tipoFinal === "2";

      const nombreFinal = esRucDetectado 
        ? (cliRazonSocial || nombres || "").trim() 
        : (nombres || (cliNombre1 || "") + " " + (cliNombre2 || "")).trim();
      
      const apellidoFinal = esRucDetectado 
        ? "" 
        : (apellidos || (cliApellido1 || "") + " " + (cliApellido2 || "")).trim();

      const fechaFormateada = (() => {
        const fecha = fechaNacimiento || cliFechaNacimiento || cliFechaConstitucion;
        if (!fecha) return "";

        if (typeof fecha === "string") {
          if (fecha.includes("/")) {
            const [dia, mes, anio] = fecha.split("/");
            return `${anio}-${mes.padStart(2, "0")}-${dia.padStart(2, "0")}`;
          }
          return fecha.split("T")[0];
        }

        return new Date(fecha).toISOString().split("T")[0];
      })();

      setForm((prev) => ({
        ...prev,
        tipoIdentificacion: tipoFinal,
        identificacion: id,
        nombres: nombreFinal,
        apellidos: apellidoFinal,
        correo: correo || cliEmail || "",
        direccion: direccion || cliDireccion || "",
        celular: celular || cliTelefono || "",
        estadoCivil: esRucDetectado ? "" : (estadoCivil || cliEstadoCivil || "").toString(),
        genero: esRucDetectado ? "" : (genero || cliCodGenero || "").toString(),
        provincia: provincia || "",
        ciudad: ciudad || "",
        fechaNacimiento: fechaFormateada,
        fechaEmisionPasaporte: fechaEmisionPasaporte || "",
        fechaCaducidadPasaporte: fechaCaducidadPasaporte || "",
        fechaIngresoPais: fechaIngresoPais || ""
      }));

      if (provincia) {
        consultarProvincia(provincia);
      }
    }
  }, [carDatosContratante]);

  const consultaRucCedula = async (identificacion, tipo) => {
    setLoading(true);
    try {
      const { consultarDatosIdentificacion } = await import("./utils/ContratanteUtils");
      const result = await consultarDatosIdentificacion(identificacion, tipo);

      if (result) {
        actualizarDesdeConsulta(result, tipo);
      }
    } catch (error) {
      console.error("Error al consultar la identificación:", error);
      addToast("Error al consultar la identificación", { appearance: "error" });
    } finally {
      setLoading(false);
    }
  };

  const consultarProvincia = async (codigoProvincia) => {
    setLoading(true);
    try {
      const resultado = await apiPost2(urlCiudadesAP, {
        empresa: "AIGMETROPOLITANA",
        codProvincia: codigoProvincia,
        ramo: "travel"
      });

      if (resultado.transaccion) {
        setCiudades(resultado.ciudades || []);
      } else {
        setCiudades([]);
      }
    } catch (error) {
      console.error("Error consultando ciudades:", error);
      addToast("Error al consultar ciudades", { appearance: "error" });
      setCiudades([]);
    }
    setLoading(false);
  };

  const validate = () => {
    const newErrors = {};
    if (!form.tipoIdentificacion) newErrors.tipoIdentificacion = "Seleccione un tipo";
    if (!form.identificacion || !validarIdentificacionEcuador(form.identificacion, form.tipoIdentificacion))
      newErrors.identificacion = "Ingrese una identificación válida";
    if (!form.nombres) {
      newErrors.nombres = "Requerido";
    } else if (form.tipoIdentificacion === "1" && !/^[a-zA-ZñÑáéíóúÁÉÍÓÚ\s]+$/.test(form.nombres)) {
      newErrors.nombres = "Solo letras y espacios";
    }

    if (form.tipoIdentificacion === "1") {
      if (!form.apellidos) {
        newErrors.apellidos = "Requerido";
      } else if (!/^[a-zA-ZñÑáéíóúÁÉÍÓÚ\s]+$/.test(form.apellidos)) {
        newErrors.apellidos = "Solo letras y espacios";
      }
    }

    if (!esRUC) {
      if (form.genero === "" || form.genero === null || form.genero === undefined) newErrors.genero = "Requerido";
      if (form.estadoCivil === "" || form.estadoCivil === null || form.estadoCivil === undefined) newErrors.estadoCivil = "Requerido";
    }

    if (form.provincia === "" || form.provincia === null || form.provincia === undefined) newErrors.provincia = "Requerido";
    if (form.ciudad === "" || form.ciudad === null || form.ciudad === undefined) newErrors.ciudad = "Requerido";
    // if (!form.fechaNacimiento) {
    //   newErrors.fechaNacimiento = "Requerido";
    // } else {
    //   const hoy = new Date();
    //   const fechaNac = new Date(form.fechaNacimiento);
    //   let edad = hoy.getFullYear() - fechaNac.getFullYear();
    //   const mes = hoy.getMonth() - fechaNac.getMonth();
    //   if (mes < 0 || (mes === 0 && hoy.getDate() < fechaNac.getDate())) {
    //     edad--;
    //   }
    //   if (!esRUC && edad < 18) {
    //     newErrors.fechaNacimiento = "El contratante debe ser mayor de 18 años";
    //   }
    // }

    if (form.tipoIdentificacion === "3") {
      if (!form.fechaEmisionPasaporte) newErrors.fechaEmisionPasaporte = "Requerido";
      if (!form.fechaCaducidadPasaporte) newErrors.fechaCaducidadPasaporte = "Requerido";
      if (!form.fechaIngresoPais) newErrors.fechaIngresoPais = "Requerido";
    }

    if (!form.correo) {
      newErrors.correo = "Requerido";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.correo)) {
      newErrors.correo = "Correo inválido";
    }

    if (!form.direccion) {
      newErrors.direccion = "Requerido";
    } else if (form.direccion.length < 5) {
      newErrors.direccion = "Mínimo 5 caracteres";
    } else if (!/^[a-zA-ZñÑáéíóúÁÉÍÓÚ0-9\s-]+$/.test(form.direccion)) {
      newErrors.direccion = "Solo letras, números, espacios y guion (-)";
    }

    if (!form.celular) {
      newErrors.celular = "Requerido";
    } else if (!/^\d{10}$/.test(form.celular)) {
      newErrors.celular = "Debe tener 10 dígitos";
    }

    setErrors(newErrors);
    const isValid = Object.keys(newErrors).length === 0;
    setMostrarAlertaForm(!isValid);
    return isValid;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validate()) {
      await validarYGuardarInformacion();
    }
  };

  const validarYGuardarInformacion = async () => {
    setLoading(true);

    const datosPagadorLimpio = {
      ...form,
      cliNombres: form.nombres ? form.nombres.trim() : '',
      cliApellidos: form.tipoIdentificacion === '2' ? '' : (form.apellidos ? form.apellidos.trim() : ''),
      direccion: form.direccion ? form.direccion.trim() : '',
    };

    const contratante = {
      esruc: form.tipoIdentificacion === '2',
      esPasaporte: form.tipoIdentificacion === '3',
      provincia: form.provincia,
      ciudad: form.ciudad,
      fechaNacimiento: form.fechaNacimiento || null,
      fechaEmisionPasaporte: form.fechaEmisionPasaporte || null,
      fechaCaducidadPasaporte: form.fechaCaducidadPasaporte || null,
      fechaIngresoPais: form.fechaIngresoPais || null,
    };

    const errores = {};
    if (!contratante.provincia) errores.provincia = true;
    if (!contratante.ciudad) errores.ciudad = true;
    // if (!contratante.fechaNacimiento) errores.fechaNacimiento = true;

    if (contratante.esPasaporte) {
      if (!contratante.fechaEmisionPasaporte) errores.fechaEmisionPasaporte = true;
      if (!contratante.fechaCaducidadPasaporte) errores.fechaCaducidadPasaporte = true;
      if (!contratante.fechaIngresoPais) errores.fechaIngresoPais = true;
    }

    if (Object.keys(errores).length > 0) {
      setErrors(prev => ({ ...prev, ...errores }));
      setLoading(false);
      return;
    }

    const datosJSON = {
      empresa: "AIGMETROPOLITANA",
      plataforma: "WEB",
      datosContratante: datosPagadorLimpio,
      datosPagadorFacturacion: datosPagadorLimpio,
      idCarrito: idCarrito,
      ambiente: "Desarrollo",
      "pasoCarrito": "guardaInfoContratante",
    };
    try {
      const response = await fetch(urlCreaFacturacionAP, { body: JSON.stringify(datosJSON), method: 'POST' })
      const json = await response.json()
      if (json.transaccion) {
        history.push({ pathname: urlContinuar, search: `?id=${idCarrito}` });
      }
      setLoading(false)
    } catch (error) {
      setLoading(false)
    }

    setLoading(false);
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Row>
        <label style={{ fontWeight: "bold" }}>Datos del contratante</label>
      </Row>
      <Row>
        <Col md={6}>
          <FormGroup>
            <Label>Tipo de identificación (*)</Label>
            <Select
              name="tipoIdentificacion"
              value={tiposIdentificacion.find(opt => opt.id === form.tipoIdentificacion)}
              onChange={(selected) => {
                setForm(prev => ({
                  ...prev,
                  tipoIdentificacion: selected.id,
                  // seguimos limpiando lo que sí se oculta (apellidos/género/estado civil) si es RUC
                  apellidos: selected.id === "2" ? "" : prev.apellidos,
                  genero: selected.id === "2" ? "" : prev.genero,
                  estadoCivil: selected.id === "2" ? "" : prev.estadoCivil,
                  // 🔸 YA NO limpiamos provincia/ciudad
                  // provincia: selected.id === "2" ? "" : prev.provincia,
                  // ciudad: selected.id === "2" ? "" : prev.ciudad,
                }));
              }}
              options={tiposIdentificacion}
              placeholder="Seleccione el tipo de documento"
              getOptionLabel={(e) => e.name}
              getOptionValue={(e) => e.id}
            />

            {errors.tipoIdentificacion && <div className="invalid-feedback d-block">{errors.tipoIdentificacion}</div>}
          </FormGroup>
        </Col>

        <Col md={6}>
          <FormGroup>
            <Label>Identificación (*)</Label>
            <Input
              type="text"
              name="identificacion"
              value={form.identificacion || ""}
              onChange={(e) => {
                const value = e.target.value;
                setForm(prev => ({ ...prev, identificacion: value }));
                if (validarIdentificacionEcuador(value, form.tipoIdentificacion)) {
                  consultaRucCedula(value, form.tipoIdentificacion);
                }
              }}
              invalid={!!errors.identificacion}
              autoComplete="off"
            />
            <FormFeedback>{errors.identificacion}</FormFeedback>
          </FormGroup>
        </Col>

        <Col md={esRUC ? 12 : 6}>
          <FormGroup>
            {/* 🔹 Cambiar label dinámicamente a Razón social si es RUC */}
            <Label>{esRUC ? "Razón social (*)" : "Nombres (*)"}</Label>
            <Input
              name="nombres"
              value={form.nombres || ""}
              placeholder={esRUC ? "Razón social" : "Nombres"}
              onChange={(e) => {
                const value = e && e.target ? e.target.value : "";
                setForm(prev => ({ ...prev, nombres: value }));
              }}
              invalid={!!errors.nombres}
              autoComplete="off"
            />
            <FormFeedback>{errors.nombres}</FormFeedback>
          </FormGroup>
        </Col>

        {/* 🔹 Ocultar Apellidos cuando sea RUC */}
        {!esRUC && (
          <Col md={6}>
            <FormGroup>
              <Label>Apellidos {form.tipoIdentificacion === "1" ? "(*)" : ""}</Label>
              <Input
                name="apellidos"
                value={form.apellidos !== null && form.apellidos !== undefined ? form.apellidos : ""}
                onChange={(e) => {
                  const value = e && e.target ? e.target.value : "";
                  setForm(prev => ({ ...prev, apellidos: value }));
                }}
                invalid={!!errors.apellidos}
                autoComplete="off"
              />
              <FormFeedback>{errors.apellidos}</FormFeedback>
            </FormGroup>
          </Col>
        )}

        {/* 🔹 Ocultar Género cuando sea RUC */}
        {!esRUC && (
          <Col md={6}>
            <FormGroup>
              <Label>Género (*)</Label>
              <Select
                name="genero"
                value={generos.find(g => g.genCodigoCore.toString() === (form.genero !== null && form.genero !== undefined ? form.genero.toString() : ""))}
                onChange={(selected) => {
                  setForm(prev => ({ ...prev, genero: selected.genCodigoCore }));
                }}
                options={generos}
                placeholder="Seleccione el género"
                getOptionLabel={(g) => g.genDescripcion}
                getOptionValue={(g) => g.genCodigoCore.toString()}
              />
              {errors.genero && <div className="invalid-feedback d-block">{errors.genero}</div>}
            </FormGroup>
          </Col>
        )}

        {/* 🔹 Ocultar Estado Civil cuando sea RUC */}
        {!esRUC && (
          <Col md={6}>
            <FormGroup>
              <Label>Estado Civil (*)</Label>
              <Select
                name="estadoCivil"
                value={estadosCiviles.find(e => e.ecivCodigoCore.toString() === (form.estadoCivil !== null && form.estadoCivil !== undefined ? form.estadoCivil.toString() : ""))}
                onChange={(selected) => {
                  setForm(prev => ({ ...prev, estadoCivil: selected.ecivCodigoCore }));
                }}
                options={estadosCiviles}
                placeholder="Seleccione el estado civil"
                getOptionLabel={(e) => e.ecivNombre}
                getOptionValue={(e) => e.ecivCodigoCore.toString()}
              />
              {errors.estadoCivil && <div className="invalid-feedback d-block">{errors.estadoCivil}</div>}
            </FormGroup>
          </Col>
        )}
        <Col md={6}>
          <FormGroup>
            <Label>Provincia (*)</Label>
            <Select
              name="provincia"
              value={provincias.find(p => p.provCodigoCore.toString() === (form.provincia !== null && form.provincia !== undefined ? form.provincia.toString() : ""))}
              onChange={(selected) => {
                setForm(prev => ({ ...prev, provincia: selected.provCodigoCore, ciudad: "" }));
                consultarProvincia(selected.provCodigoCore);
              }}
              options={provincias}
              placeholder="Seleccione la provincia"
              getOptionLabel={(p) => p.label}
              getOptionValue={(p) => p.provCodigoCore.toString()}
            />
            {errors.provincia && <div className="invalid-feedback d-block">{errors.provincia}</div>}
          </FormGroup>
        </Col>
        <Col md={6}>
          <FormGroup>
            <Label>Ciudad (*)</Label>
            <Select
              name="ciudad"
              value={ciudades.find(c => c.value.toString() === (form.ciudad !== null && form.ciudad !== undefined ? form.ciudad.toString() : ""))}
              onChange={(selected) => {
                setForm(prev => ({ ...prev, ciudad: selected.value }));
              }}
              options={ciudades}
              placeholder="Seleccione la ciudad"
              isDisabled={ciudades.length === 0}
            />
            {errors.ciudad && <div className="invalid-feedback d-block">{errors.ciudad}</div>}
          </FormGroup>
        </Col>

        {/* 🔹 Cambiar label de fecha dinámicamente */}
        {/* <Col md={6}>
          <FormGroup>
            <Label>{esRUC ? "Fecha de constitución (*)" : "Fecha de nacimiento (*)"}</Label>
            <div className="w-100">
              <DatePicker
                selected={form.fechaNacimiento ? moment(form.fechaNacimiento).toDate() : null}
                onChange={(date) => {
                  const value = date ? moment(date).format("YYYY-MM-DD") : "";
                  setForm(prev => ({ ...prev, fechaNacimiento: value }));
                }}
                dateFormat="yyyy/MM/dd"
                className={`form-control ${errors.fechaNacimiento ? "is-invalid" : ""}`}
                wrapperClassName="w-100"
                placeholderText="AAAA/MM/DD"
                autoComplete="off"
                peekNextMonth
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
              />
            </div>
            <FormFeedback>{errors.fechaNacimiento}</FormFeedback>
          </FormGroup>
        </Col> */}

        {form.tipoIdentificacion === "3" && (
          <>
            <Col md={6}>
              <FormGroup>
                <Label>Fecha emisión pasaporte (*)</Label>
                <div className="w-100">
                  <DatePicker
                    selected={form.fechaEmisionPasaporte ? moment(form.fechaEmisionPasaporte).toDate() : null}
                    onChange={(date) => {
                      const value = date ? moment(date).format("YYYY-MM-DD") : "";
                      setForm(prev => ({ ...prev, fechaEmisionPasaporte: value }));
                    }}
                    dateFormat="yyyy/MM/dd"
                    className={`form-control ${errors.fechaEmisionPasaporte ? "is-invalid" : ""}`}
                    placeholderText="AAAA/MM/DD"
                    autoComplete="off"
                    peekNextMonth
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                  />
                </div>
                <FormFeedback>{errors.fechaEmisionPasaporte}</FormFeedback>
              </FormGroup>
            </Col>

            <Col md={6}>
              <FormGroup>
                <Label>Fecha caducidad pasaporte (*)</Label>
                <div className="w-100">
                  <DatePicker
                    selected={form.fechaCaducidadPasaporte ? moment(form.fechaCaducidadPasaporte).toDate() : null}
                    onChange={(date) => {
                      const value = date ? moment(date).format("YYYY-MM-DD") : "";
                      setForm(prev => ({ ...prev, fechaCaducidadPasaporte: value }));
                    }}
                    dateFormat="yyyy/MM/dd"
                    className={`form-control ${errors.fechaCaducidadPasaporte ? "is-invalid" : ""}`}
                    placeholderText="AAAA/MM/DD"
                    autoComplete="off"
                    peekNextMonth
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                  />
                </div>
                <FormFeedback>{errors.fechaCaducidadPasaporte}</FormFeedback>
              </FormGroup>
            </Col>

            <Col md={6}>
              <FormGroup>
                <Label>Fecha ingreso al país (*)</Label>
                <div className="w-100">
                  <DatePicker
                    selected={form.fechaIngresoPais ? moment(form.fechaIngresoPais).toDate() : null}
                    onChange={(date) => {
                      const value = date ? moment(date).format("YYYY-MM-DD") : "";
                      setForm(prev => ({ ...prev, fechaIngresoPais: value }));
                    }}
                    dateFormat="yyyy/MM/dd"
                    className={`form-control ${errors.fechaIngresoPais ? "is-invalid" : ""}`}
                    placeholderText="AAAA/MM/DD"
                    autoComplete="off"
                    peekNextMonth
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                  />
                </div>
                <FormFeedback>{errors.fechaIngresoPais}</FormFeedback>
              </FormGroup>
            </Col>
          </>
        )}

        <Col md={6}>
          <FormGroup>
            <Label>Correo Electrónico (*)</Label>
            <Input
              type="email"
              name="correo"
              value={form.correo || ""}
              onChange={(e) => {
                var value = e && e.target ? e.target.value : "";
                setForm((prev) => ({ ...prev, correo: value }));
              }}
              invalid={!!errors.correo}
              autoComplete="off"
            />
            <FormFeedback>{errors.correo}</FormFeedback>
          </FormGroup>
        </Col>

        <Col md={6}>
          <FormGroup>
            <Label>Dirección (*)</Label>
            <Input name="direccion" value={form.direccion || ""} onChange={(e) => {
              var value = e && e.target ? e.target.value : "";
              setForm(prev => ({ ...prev, direccion: value }))
            }} invalid={!!errors.direccion} autoComplete="off" />
            <FormFeedback>{errors.direccion}</FormFeedback>
          </FormGroup>
        </Col>

        <Col md={6}>
          <FormGroup>
            <Label>Celular (*)</Label>
            <Input name="celular" value={form.celular || ""} onChange={(e) => {
              var value = e && e.target ? e.target.value : "";
              setForm(prev => ({ ...prev, celular: value }))
            }} invalid={!!errors.celular} autoComplete="off" />
            <FormFeedback>{errors.celular}</FormFeedback>
          </FormGroup>
        </Col>
      </Row>

      {mostrarAlertaForm ? (
        <div>
          <br></br>
          <Alert color="warning">
            <center><p>Por favor, complete todos los campos obligatorios para continuar.</p></center>
          </Alert>
        </div>
      ) : null}

      <Card>
        <CardBody style={{ display: "flex", justifyContent: "space-between" }}>
          <Button
            onClick={() =>
              history.push({
                pathname: urlRegresar,
                search: `?id=${idCarrito}`,
              })
            }
            style={{ backgroundColor: "#001871", color: "white", border: "none" }}
          >
            <i className="fa fa-chevron-circle-left" /> &nbsp;REGRESAR
          </Button>
          <Button
            type="submit"
            style={{ backgroundColor: "#001871", color: "white", border: "none" }}
          >
            CONTINUAR &nbsp;<i className="fa fa-chevron-circle-right" />
          </Button>
        </CardBody>
      </Card>
    </Form>
  );
};

export default FormularioContratante;
